import { metaDataService } from '@/services/metaDataService/metaDataService';
import { Country, Language } from '@/types/metaData';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../..';

interface MetaDataState {
  languages: Language[];
  countries: Country[];
  loading: boolean;
  error: string | null;
}

const initialState: MetaDataState = {
  languages: [],
  countries: [],
  loading: false,
  error: null,
};

// Async thunk
export const fetchMetaData = createAsyncThunk(
  'metaData/fetchAll',
  async () => {
    const [languagesRes, countriesRes] = await Promise.all([
      metaDataService.getLanguagesList(),
      metaDataService.getCountriesList(),
    ]);

    return {
      languages: languagesRes.data,
      countries: countriesRes.data,
    };
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as RootState;
      const { languages, countries } = state.metaData;

      if (languages.length > 0 && countries.length > 0) {
        return false;
      }

      return true;
    },
  },
);

const metaDataSlice = createSlice({
  name: 'metaData',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMetaData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMetaData.fulfilled, (state, action) => {
        state.loading = false;
        state.languages = action.payload.languages;
        state.countries = action.payload.countries;
      })
      .addCase(fetchMetaData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch meta data';
      });
  },
});

export default metaDataSlice.reducer;
